<template>
  <div>
    <div v-for="(item, index) in markerList" :key="index">
      <TraceSourceMarker :marker-info="item"></TraceSourceMarker>
    </div>
  </div>
</template>

<script>
import TraceSourceMarker from "@/components/TraceSourceEntry/TraceSourceMarker.vue";

export default {
  components: {TraceSourceMarker},
  props: ['markerList'],
}
</script>

<style scoped>

</style>